import React, {useState} from "react";
import { withRouter } from "react-router-dom";

function TemplatesSearch(props) {
    const {isInSearch, setSearchTemplates, setIsInSearch, fetchSearchTemplatesList} = props;

    const searchString = (search) => {
        if (search.length > 2) {
            fetchSearchTemplatesList(search);
            !isInSearch && setIsInSearch(true);
        } else if (isInSearch) {
            setSearchTemplates([]);
            setIsInSearch(false);
        }
    }

    const onSearch = (e) => {
        searchString(e.target.value);
    }

    const onKeyPress = (e) => {
        if(e.key === "Enter") {
            props.history.push("/survey-templates");
            searchString(e.target.value);
        }
    };

    return (
        <input
            className="search_input"
            type="text"
            onChange={onSearch}
            onKeyPress={onKeyPress}
            maxLength={52}
            placeholder="Search..." />
    );
}

export default withRouter(TemplatesSearch);